import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { Pillar } from '../interfaces/models/strategy.model';
import { filterActive } from '../utils/filter-active';


@Injectable({
  providedIn: 'root'
})
export class StrategicPillarService {
  constructor(private http: HttpClient) { }
  private domain = environment.domain;
  getListPillars(id: number) {
    return this.http.get(this.domain + `strategies/${id}/pillars`).pipe(map((data: any) => {
      return filterActive(data["data"]["pillars"]);
    }))
  }
  createPillars(model: Partial<Pillar>, strategyId: number) {
    return this.http.post(this.domain + `strategies/${strategyId}/pillars`, model);
  }
  updatePillars(model: Partial<Pillar>, strategyId: number, pillarId: number) {
    return this.http.put(this.domain + `strategies/${strategyId}/pillars/${pillarId}`, model);
  }
  deletePillars(strategyId: number, PillarId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/pillars/${PillarId}`);
  }
}